import {
    React,
    PropTypes,
    TextField,
    UI,
    useIntl,
    isSubmittingSelector,
    useSelector,
} from '../../../../../dependencies';

const { InputWrapper } = UI;

const Password = ({ formId }) => {
    const intl = useIntl();
    const isSubmitting = useSelector(isSubmittingSelector(formId));

    return (
        <InputWrapper gridArea="password">
            <TextField
                name="password"
                label={intl.formatMessage({
                    id: 'export.recurring.form.password.label',
                })}
                placeholder={intl.formatMessage({
                    id: 'export.recurring.form.password.placeholder',
                })}
                disabled={isSubmitting}
                type="password"
                autoComplete="disabled"
            />
        </InputWrapper>
    );
};

Password.propTypes = {
    formId: PropTypes.string.isRequired,
};

export default Password;
